import React, {
  FC,
  Fragment,
  PropsWithChildren,
  useContext,
  useRef,
  useState,
} from "react";
import styled from "styled-components";
import { getDistance } from "../functions/getDistance";
import { ScrollBarConfig } from "../functions/ScrollBarConfig";
import { Store } from "../interfaces/IStore";
import { AppContext } from "./AppContext";
import AirbnbResults from "./Icons/AirbnbResults";
import HotelResults from "./Icons/HotelResults";
import StoreResults from "./Icons/StoreResults";
import { MapContext } from "./MapContext";

interface IStoreList {
  onClick: (store: Store) => void;
}
const Filters = styled.div`
  overflow-y: scroll;
  flex-shrink: 1;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  margin: 0.2rem 0 0 0.4rem;
  margin-left: 0.9rem;
  margin-right: 0.9rem;
  // ::-webkit-scrollbar {
  //   display: none;
  // }

  ${ScrollBarConfig}
`;

const StoreCardMainContainer = styled.div`
  margin: 0.8rem 0.6rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const StoreCardHeader = styled.div`
  display: flex;
  flex-flow: row;
  align-items: center;
  flex-grow: 1;
  flex-shrink: 1;
`;

const DistanceContainer = styled.div`
  display: flex;
  flex-flow: row;
  align-items: center;
  flex-grow: 0;
  flex-shrink: 0;
`;

const ResultCardStoreTitle = styled.p`
  font-size: 18px;
  line-height: 1.3;
  letter-spacing: 0.5px;
  margin: 0px 0;
  cursor: pointer;
  padding-left: 10px;
`;

const ResultsContainer = styled.div`
  display: flex;
  flex-flow: column;
  overflow-y: hidden;
  margin: 0;
  border-top: 0.2rem solid white;
  height: auto;
  padding-top: 0.4rem;
  max-height: calc(100vh - 51px - 0.6rem - 135px - 14rem);
  border-bottom: 1px solid #c0bebe;
`;

export const MobileResultsList: FC<PropsWithChildren<IStoreList>> = ({
  onClick,
}) => {
  const { stores } = useContext(AppContext);
  const { sortCoords } = useContext(MapContext);
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const containerRef = useRef() as React.MutableRefObject<HTMLDivElement>;

  return (
    <Fragment>
      <ResultsContainer ref={containerRef}>
        <Filters>
          {stores.map((store, index) => {
            const distance = (
              getDistance(
                [sortCoords.lat, sortCoords.lng],
                [store.latitude, store.longitude]
              ) / 1000
            ).toFixed(0);
            return (
              <StoreCardMainContainer key={index}>
                <StoreCardHeader onClick={() => onClick(store)}>
                  <div>
                    {store.business_type === "airbnb" ? (
                      <AirbnbResults />
                    ) : store.business_type === "hotel" ? (
                      <HotelResults />
                    ) : (
                      <StoreResults />
                    )}
                  </div>
                  <ResultCardStoreTitle>{store.name_en}</ResultCardStoreTitle>
                </StoreCardHeader>
                <DistanceContainer>{distance}km</DistanceContainer>
              </StoreCardMainContainer>
            );
          })}
        </Filters>
      </ResultsContainer>
    </Fragment>
  );
};
